import { enumElementDrawStates, enumPadBorderType } from "../constants";
import { QTabButton } from "./QTabButton";
import { shadeColor } from "../utils/shadeColor";
import { Globals } from "./Globals.js";

export class QPanelTabButton extends QTabButton {
  constructor() {
    super();
    this.fPanelTab = true;
  }

  DoRenderElement(drawBuffer) {
    var txtFillStyle = this.fUIColors.GetHeaderTextColor();
    var ds = this.GetDrawState();
    // Draw the button (interior and border)
    switch (ds) {
      case enumElementDrawStates.Std:
        this.DrawPad(drawBuffer, this.fIsActive || this.fSelected, false);
        break;
      case enumElementDrawStates.Hover:
        this.DrawPad(drawBuffer, false, this.fIsActive || this.fSelected, true);
        break;
      case enumElementDrawStates.MouseDown:
        this.DrawPad(drawBuffer, false, this.fIsActive || this.fSelected, false);
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = "#AFAFAF";
        break;
    }

    // draw label
    this.DrawLabel(drawBuffer);
  }

  DrawPad(drawBuffer, mouseDown, selected, hover) {
    var ctx = drawBuffer.getContext("2d");
    var r2d = Math.PI / 180;
    ctx.save();
    ctx.strokeStyle = Globals._themeMode.text.body;
    ctx.lineWidth = 1;
    var r = 0;
    var sx = this.fHorzOffset + 0.5;
    var sy = this.fVertOffset + 0.5;
    var ex = this.fHorzOffset + this.fWidth - 0.5;
    var ey = this.fVertOffset + this.fHeight - 0.5;

    var bt = this.fPadBorderType;
    switch (bt) {
      case enumPadBorderType.fullBorder:
        ctx.beginPath();
        ctx.moveTo(sx + r, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx + r, ey);
        ctx.arc(sx + r, ey - r, r, r2d * 90, r2d * 180, false);
        ctx.lineTo(sx, sy + r);
        ctx.arc(sx + r, sy + r, r, r2d * 180, r2d * 270, false);
        ctx.closePath();
        ctx.stroke();
        break;
      case enumPadBorderType.leftBorder:
        ctx.beginPath();
        ctx.moveTo(ex + 0.5, sy);
        ctx.lineTo(sx + r, sy);
        ctx.arc(sx + r, sy + r, r, r2d * 270, r2d * 180, true);
        ctx.lineTo(sx, ey - r);
        ctx.arc(sx + r, ey - r, r, r2d * 180, r2d * 90, true);
        ctx.lineTo(ex + 0.5, ey);
        ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.rightBorder:
        ctx.beginPath();
        ctx.moveTo(sx - 0.5, sy);
        ctx.lineTo(ex - r, sy);
        ctx.arc(ex - r, sy + r, r, r2d * 270, r2d * 360, false);
        ctx.lineTo(ex, ey - r);
        ctx.arc(ex - r, ey - r, r, r2d * 0, r2d * 90, false);
        ctx.lineTo(sx - 0.5, ey);
        ctx.stroke();
        ctx.closePath();
        break;
      case enumPadBorderType.middleBorder:
        ctx.beginPath();
        ctx.moveTo(sx - 0.5, sy);
        ctx.lineTo(ex + 0.5, sy);
        ctx.stroke();
        ctx.moveTo(sx - 0.5, ey);
        ctx.lineTo(ex + 0.5, ey);
        ctx.stroke();
        ctx.lineTo(ex + 0.5, sy);
        ctx.lineTo(sx - 0.5, sy);
        ctx.closePath();
        break;
    }

    var fillColor = ctx.createLinearGradient(0.5, sy - 200, 0.5, ey);
    if (mouseDown || selected) {
      fillColor.addColorStop(0, shadeColor(this.fFillColor, -17));
      fillColor.addColorStop(1, shadeColor(this.fFillColor, -25));
    } else if (hover) {
      fillColor.addColorStop(0, "#EEEEEE");
      fillColor.addColorStop(1, shadeColor(this.fFillColor, -5));
    } else {
      fillColor.addColorStop(0, "#EEEEEE");
      fillColor.addColorStop(1, shadeColor(this.fFillColor, -15));
    }
    ctx.fillStyle = fillColor;
    ctx.fill();
    ctx.restore();
  }

  GetCursor() {
    return "pointer";
  }
}
